<template>
    <b-row v-if="$store.state.loading" class="my-2"> 
        <b-col sm="12" class="text-center">
            
            <!-- <h5 class="mb-3">{{$t('loading')}}</h5> -->
            
            <b-spinner 
                label="Loading..." 
                type="border" 
                variant="primary" 
                style="width: 2rem; height: 2rem;" 
            />
            
            </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'LoaderSmall'
}
</script>